import {NavigationPageEnum, NavigationPageEnumHumanReadable} from '../../navigations.enums';
import {IUserAccessFeature, IUserAccessSubFeatures} from '../user-access-features';
import {SettingsReferenceEnum} from '../../../../settings-new/models';
import {IUserAccessFeatureShelfTalkerSettings} from '../access';
import {_FEATURE_LABEL_MAKER_DEFAULT} from './feature-label-maker.interface';

//#region INTERFACE IFeatureShelfTalkerGeneralSettings
export interface IFeatureShelfTalkerGeneralSettings extends IUserAccessSubFeatures, IUserAccessFeature, Object {
}

//#endregion

//#region CONST _FEATURE_SHELF_TALKER_GENERAL_SETTINGS_DEFAULT
export const _FEATURE_SHELF_TALKER_GENERAL_SETTINGS_DEFAULT: Readonly<IFeatureShelfTalkerGeneralSettings & Object> = {
  displayText: NavigationPageEnumHumanReadable.General,
  feature: NavigationPageEnum.ShelfTalkersGeneral,
  ref: SettingsReferenceEnum.featureShelfTalkerGeneral,
  standalone: true,
};
//#endregion

//#region INTERFACE IFeatureShelfTalkers
export interface IFeatureShelfTalkers extends IUserAccessFeature, Object {
  crudAccess: { [storeId: string]: IUserAccessFeatureShelfTalkerSettings };
}

//#endregion

//#region CONST _FEATURE_SHELF_TALKERS_DEFAULT
export const _FEATURE_SHELF_TALKERS_DEFAULT: Readonly<IFeatureShelfTalkers & Object> = {
  displayText: NavigationPageEnumHumanReadable.ShelfTalkers,
  feature: NavigationPageEnum.ShelfTalkers,
  ref: SettingsReferenceEnum.featureShelfTalkers,
  standalone: false,
  subFeatures: [
    {..._FEATURE_SHELF_TALKER_GENERAL_SETTINGS_DEFAULT},
    {..._FEATURE_LABEL_MAKER_DEFAULT},
  ],
  crudAccess: {},
};
//#endregion